<script lang="ts">
    import { afterNavigate, beforeNavigate } from '$app/navigation';
    import { page } from '$app/stores';
    import { PUBLIC_CANONICAL_HOST, PUBLIC_POSTHOG_API_KEY } from '$env/static/public';
    import ToastContainer from '$lib/components/util/ToastContainer.svelte';
    import { useContactFormData } from '$lib/stores.js';
    import { QueryClientProvider } from '@tanstack/svelte-query';
    import posthog from 'posthog-js';
    import { onMount } from 'svelte';
    import '../../css/app.pcss';
    import type { LayoutData } from './$types';

    useContactFormData();

    export let data: LayoutData;
    let posthogInitialized = false;
    type KlaroConsents = 'posthog';

    function buildCanonicalUrl(pageUrl: URL) {
        const canonicalUrl = new URL(pageUrl.toString());
        canonicalUrl.host = PUBLIC_CANONICAL_HOST;
        canonicalUrl.port = '';
        canonicalUrl.protocol = 'https';

        return canonicalUrl;
    }

    $: canonicalUrl = buildCanonicalUrl($page.url);

    function onKlaroLoaded() {
        if (window.klaro.getManager().getConsent('posthog')) {
            posthog.init(PUBLIC_POSTHOG_API_KEY, {
                api_host: 'https://eu.i.posthog.com',
                person_profiles: 'identified_only',
                autocapture: true,
                capture_pageview: true,
                capture_pageleave: true,
                debug: false
            });
            posthogInitialized = true;
        }
        window.klaro.getManager().watch({
            update: (object: unknown, name: 'consents', data: Record<KlaroConsents, boolean>) => {
                if (name === 'consents') {
                    if (data.posthog) {
                        posthog.init(PUBLIC_POSTHOG_API_KEY, {
                            api_host: 'https://eu.i.posthog.com',
                            person_profiles: 'identified_only',
                            autocapture: true,
                            capture_pageview: false,
                            capture_pageleave: false
                        });
                        posthogInitialized = true;
                    }
                }
            }
        });
    }

    onMount(() => {
        if (window.klaro) {
            onKlaroLoaded();
        } else {
            window.klaroLoadWatchers ??= [];
            window.klaroLoadWatchers.push(onKlaroLoaded);
        }
    });

    $: if (posthogInitialized) {
        beforeNavigate(() => posthog.capture('$pageleave'));
        afterNavigate(() => posthog.capture('$pageview'));
    }
</script>

<svelte:head>
    <link rel="canonical" href={canonicalUrl.toString()} />
</svelte:head>

<ToastContainer />
<QueryClientProvider client={data.queryClient}>
    <slot />
</QueryClientProvider>
